<template>
  <div>
    <Header />
    <SeasonSavedComponent />
    <Footer />
  </div>
</template>

<script>
import SeasonSavedComponent from '@/components/Season/Saved.vue'
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'SeasonSaved',
  components: {
    SeasonSavedComponent,
    Header,
    Footer
  },
  mounted() {
    this.$store.dispatch('season/getSeasonProgress')
  },
  destroyed() {
    this.$store.dispatch('season/clear')
  },
}
</script>
